module.exports = __webpack_public_path__ + "img/logoCHTavira.d3aa4fd7.jpg";